// Shared messages between client and API
export const ERRORS = {
  PROD_BETA_STAFF_ONLY: 'Access to the beta site is restricted to staff members only',
};
